import { render } from "./DetailsStep.vue?vue&type=template&id=0e10460f&scoped=true"
import script from "./DetailsStep.vue?vue&type=script&lang=js"
export * from "./DetailsStep.vue?vue&type=script&lang=js"

import "./DetailsStep.vue?vue&type=style&index=0&id=0e10460f&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e10460f"]])

export default __exports__